/**
 * Graficos Data - Resumo
 *
 * Gráfico 5: Sobras vs Faltas (últimas 4 semanas)
 * Cards do Dashboard: Resumo de Estatísticas
 * Gráfico Dashboard: Produtos por Categoria
 */

// ============================================================
// GRÁFICO 5: SOBRAS vs FALTAS (últimas 4 semanas)
// ============================================================

export interface SobrasVsFaltasData {
  periodo: string;
  sobras: number;
  faltas: number;
  total: number;
  razao: number;
  interpretacao: string;
}

export const sobrasVsFaltas: SobrasVsFaltasData[] = [
  {
    periodo: 'Semana 1',
    sobras: 15,
    faltas: 8,
    total: 23,
    razao: 1.88,
    interpretacao: 'Mais sobras que faltas - Sistema pode estar desatualizado'
  },
  {
    periodo: 'Semana 2',
    sobras: 12,
    faltas: 6,
    total: 18,
    razao: 2.0,
    interpretacao: 'Proporção 2:1 sobras/faltas - Revisar processo de atualização'
  },
  {
    periodo: 'Semana 3',
    sobras: 18,
    faltas: 10,
    total: 28,
    razao: 1.8,
    interpretacao: 'Alto volume de divergências - Investigar causas'
  },
  {
    periodo: 'Semana 4',
    sobras: 10,
    faltas: 5,
    total: 15,
    razao: 2.0,
    interpretacao: 'Melhoria na redução total, mas proporção mantida'
  }
];

// ============================================================
// RESUMO DE ESTATÍSTICAS (para cards do Dashboard)
// ============================================================

export interface ResumoEstatisticas {
  acuracidadeAtual: number;
  meta: number;
  acimaDaMeta: boolean;
  totalHospitais: number;
  hospitaisAtivos: number;
  totalContagensUltimos30Dias: number;
  totalProdutosContados: number;
  totalDivergencias: number;
  tendenciaAcuracidade: 'SUBINDO' | 'ESTÁVEL' | 'DESCENDO';
}

export const resumoEstatisticas: ResumoEstatisticas = {
  acuracidadeAtual: 97.2,
  meta: 95.0,
  acimaDaMeta: true,
  totalHospitais: 12,
  hospitaisAtivos: 10,
  totalContagensUltimos30Dias: 95,
  totalProdutosContados: 5432,
  totalDivergencias: 190,
  tendenciaAcuracidade: 'SUBINDO'
};

// ============================================================
// GRÁFICO DASHBOARD: PRODUTOS POR CATEGORIA
// ============================================================

export interface ProdutosPorCategoriaData {
  categoria: string;
  quantidade: number;
  porcentagem: number;
  valorTotal: number;
}

export const produtosPorCategoria: ProdutosPorCategoriaData[] = [
  {
    categoria: 'Prótese Ortopédica',
    quantidade: 842,
    porcentagem: 24.4,
    valorTotal: 12400000
  },
  {
    categoria: 'Cardiologia',
    quantidade: 687,
    porcentagem: 19.9,
    valorTotal: 9800000
  },
  {
    categoria: 'Cirurgia Geral',
    quantidade: 534,
    porcentagem: 15.4,
    valorTotal: 4200000
  },
  {
    categoria: 'Oftalmologia',
    quantidade: 412,
    porcentagem: 11.9,
    valorTotal: 2800000
  },
  {
    categoria: 'Ortopedia',
    quantidade: 378,
    porcentagem: 10.9,
    valorTotal: 3100000
  },
  {
    categoria: 'Cirurgia Vascular',
    quantidade: 298,
    porcentagem: 8.6,
    valorTotal: 5600000
  },
  {
    categoria: 'Neurocirurgia',
    quantidade: 187,
    porcentagem: 5.4,
    valorTotal: 3900000
  },
  {
    categoria: 'Outros',
    quantidade: 118,
    porcentagem: 3.4,
    valorTotal: 1800000
  }
];
